import { History } from "history";

import {
  ADD_FLASH_CARD,
  ADD_FLASH_CARD_ERROR,
  ADD_FLASH_CARD_SUCCESS,
  AddFlashCardAction,
  AddFlashCardErrorAction,
  AddFlashCardSuccessAction,
  DELETE_ALL_FLASH_CARD,
  DELETE_ALL_FLASH_CARD_CONSENT,
  DELETE_ALL_FLASH_CARD_ERROR,
  DELETE_ALL_FLASH_CARD_SUCCESS,
  DELETE_FLASH_CARD,
  DELETE_FLASH_CARD_CONSENT,
  DELETE_FLASH_CARD_ERROR,
  DELETE_FLASH_CARD_SUCCESS,
  DeleteAllFlashCardAction,
  DeleteAllFlashCardConsentAction,
  DeleteAllFlashCardErrorAction,
  DeleteAllFlashCardSuccessAction,
  DeleteFlashCardAction,
  DeleteFlashCardConsentAction,
  DeleteFlashCardErrorAction,
  DeleteFlashCardSuccessAction,
  GET_FLASH_CARD,
  GET_FLASH_CARDS,
  GET_FLASH_CARDS_BY_LESSON,
  GET_FLASH_CARDS_BY_LESSON_ERROR,
  GET_FLASH_CARDS_BY_LESSON_SUCCESS,
  GET_FLASH_CARDS_ERROR,
  GET_FLASH_CARDS_SUCCESS,
  GET_FLASH_CARD_ERROR,
  GET_FLASH_CARD_SUCCESS,
  GetFlashCardAction,
  GetFlashCardErrorAction,
  GetFlashCardSuccessAction,
  GetFlashCardsAction,
  GetFlashCardsByLessonAction,
  GetFlashCardsByLessonErrorAction,
  GetFlashCardsByLessonSuccessAction,
  GetFlashCardsErrorAction,
  GetFlashCardsSuccessAction,
  REMOVE_UPLOADED_FLASH_CARD_IMAGE,
  RemoveUploadedFlashCardImageAction,
  TOGGLE_ADD_EDIT_FLASH_CARD_MODAL,
  TOGGLE_FLASH_CARD_STATE,
  TOGGLE_FLASH_CARD_STATE_CONSENT,
  TOGGLE_FLASH_CARD_STATE_ERROR,
  TOGGLE_FLASH_CARD_STATE_SUCCESS,
  ToggleAddEditFlashCardModalAction,
  ToggleFlashCardStateAction,
  ToggleFlashCardStateConsentAction,
  ToggleFlashCardStateErrorAction,
  ToggleFlashCardStateSuccessAction,
  UPDATE_FLASH_CARD,
  UPDATE_FLASH_CARD_ERROR,
  UPDATE_FLASH_CARD_SUCCESS,
  UPLOAD_AND_CREATE_FLASH_CARD,
  UPLOAD_AND_CREATE_FLASH_CARD_ERROR,
  UPLOAD_AND_CREATE_FLASH_CARD_PROGRESS,
  UPLOAD_AND_CREATE_FLASH_CARD_SUCCESS,
  UPLOAD_FLASH_CARD_IMAGE,
  UPLOAD_FLASH_CARD_IMAGE_ERROR,
  UPLOAD_FLASH_CARD_IMAGE_SUCCESS,
  UpdateFlashCardAction,
  UpdateFlashCardErrorAction,
  UpdateFlashCardSuccessAction,
  UploadAndCreateFlashCardAction,
  UploadAndCreateFlashCardErrorAction,
  UploadAndCreateFlashCardProgressAction,
  UploadAndCreateFlashCardSuccessAction,
  UploadFlashCardImageAction,
  UploadFlashCardImageErrorAction,
  UploadFlashCardImageSuccessAction,
} from "./actionTypes";
import { PaginateQuery } from "../../interfaces";
import { Paginated } from "../../models";
import {
  CreateMediaError,
  MediaDto,
  UploadAndCreateFlashCardRequest,
  UploadAndCreateFlashCardResponse,
} from "../../interfaces/media";
import {
  CreateFlashCardRequest,
  FlashCardDto,
  UpdateFlashCardRequest,
} from "../../interfaces/flash-card";
import { CreateMediaProgress } from "../../interfaces/media/create-media-progress.dto";

//#region Get FlashCards

export const getFlashCards = (
  request: PaginateQuery,
  history: History
): GetFlashCardsAction => {
  return {
    type: GET_FLASH_CARDS,
    payload: { request, history },
  };
};

export const getFlashCardsSuccess = (
  response: Paginated<FlashCardDto>
): GetFlashCardsSuccessAction => {
  return {
    type: GET_FLASH_CARDS_SUCCESS,
    payload: response,
  };
};

export const getFlashCardsError = (error: any): GetFlashCardsErrorAction => {
  return {
    type: GET_FLASH_CARDS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get FlashCards by Lesson Id

export const getFlashCardsByLesson = (
  lessonId: string,
  history: History
): GetFlashCardsByLessonAction => {
  return {
    type: GET_FLASH_CARDS_BY_LESSON,
    payload: { lessonId, history },
  };
};

export const getFlashCardsByLessonSuccess = (
  response: FlashCardDto[]
): GetFlashCardsByLessonSuccessAction => {
  return {
    type: GET_FLASH_CARDS_BY_LESSON_SUCCESS,
    payload: response,
  };
};

export const getFlashCardsByLessonError = (
  error: any
): GetFlashCardsByLessonErrorAction => {
  return {
    type: GET_FLASH_CARDS_BY_LESSON_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get FlashCard

export const getFlashCard = (
  id: string,
  history: History
): GetFlashCardAction => {
  return {
    type: GET_FLASH_CARD,
    payload: { id, history },
  };
};

export const getFlashCardSuccess = (
  response: FlashCardDto
): GetFlashCardSuccessAction => {
  return {
    type: GET_FLASH_CARD_SUCCESS,
    payload: response,
  };
};

export const getFlashCardError = (error: any): GetFlashCardErrorAction => {
  return {
    type: GET_FLASH_CARD_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add FlashCard

export const addFlashCard = (
  request: CreateFlashCardRequest,
  history: History
): AddFlashCardAction => {
  return {
    type: ADD_FLASH_CARD,
    payload: { request, history },
  };
};

export const addFlashCardSuccess = (
  skill: FlashCardDto
): AddFlashCardSuccessAction => {
  return {
    type: ADD_FLASH_CARD_SUCCESS,
    payload: skill,
  };
};

export const addFlashCardError = (error: any): AddFlashCardErrorAction => {
  return {
    type: ADD_FLASH_CARD_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update FlashCard

export const updateFlashCard = (
  id: string,
  request: UpdateFlashCardRequest,
  history: History
): UpdateFlashCardAction => {
  return {
    type: UPDATE_FLASH_CARD,
    payload: { id, request, history },
  };
};

export const updateFlashCardSuccess = (
  skill: FlashCardDto
): UpdateFlashCardSuccessAction => {
  return {
    type: UPDATE_FLASH_CARD_SUCCESS,
    payload: skill,
  };
};

export const updateFlashCardError = (
  error: any
): UpdateFlashCardErrorAction => {
  return {
    type: UPDATE_FLASH_CARD_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete FlashCard

export const deleteFlashCardConsent = (
  id: string
): DeleteFlashCardConsentAction => {
  return {
    type: DELETE_FLASH_CARD_CONSENT,
    payload: id,
  };
};

export const deleteFlashCard = (
  id: string,
  history: History
): DeleteFlashCardAction => {
  return {
    type: DELETE_FLASH_CARD,
    payload: { id, history },
  };
};

export const deleteFlashCardSuccess = (
  id: string
): DeleteFlashCardSuccessAction => {
  return {
    type: DELETE_FLASH_CARD_SUCCESS,
    payload: id,
  };
};

export const deleteFlashCardError = (
  error: any
): DeleteFlashCardErrorAction => {
  return {
    type: DELETE_FLASH_CARD_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload FlashCard Image

export const uploadFlashCardImage = (
  file: File,
  history: History,
  flashCardId?: string
): UploadFlashCardImageAction => {
  return {
    type: UPLOAD_FLASH_CARD_IMAGE,
    payload: { file, history, flashCardId },
  };
};

export const uploadFlashCardImageSuccess = (
  media: MediaDto
): UploadFlashCardImageSuccessAction => {
  return {
    type: UPLOAD_FLASH_CARD_IMAGE_SUCCESS,
    payload: media,
  };
};

export const uploadFlashCardImageError = (
  error: any
): UploadFlashCardImageErrorAction => {
  return {
    type: UPLOAD_FLASH_CARD_IMAGE_ERROR,
    payload: error,
  };
};

//#endregion

//#region add edit skill modal
export const toggleAddEditFlashCardModal =
  (): ToggleAddEditFlashCardModalAction => {
    return {
      type: TOGGLE_ADD_EDIT_FLASH_CARD_MODAL,
      payload: null,
    };
  };
//#endregion

//#region Delete FlashCard All

export const deleteAllFlashCardConsent = (
  lessonId: string
): DeleteAllFlashCardConsentAction => {
  return {
    type: DELETE_ALL_FLASH_CARD_CONSENT,
    payload: lessonId,
  };
};

export const deleteAllFlashCard = (
  lessonId: string,
  history: History
): DeleteAllFlashCardAction => {
  return {
    type: DELETE_ALL_FLASH_CARD,
    payload: { lessonId, history },
  };
};

export const deleteAllFlashCardSuccess = (
  lessonId: string
): DeleteAllFlashCardSuccessAction => {
  return {
    type: DELETE_ALL_FLASH_CARD_SUCCESS,
    payload: lessonId,
  };
};

export const deleteAllFlashCardError = (
  error: any
): DeleteAllFlashCardErrorAction => {
  return {
    type: DELETE_ALL_FLASH_CARD_ERROR,
    payload: error,
  };
};

//#endregion

//#region Toggle FlashCard State

export const toggleFlashCardStateConsent = (
  id: string
): ToggleFlashCardStateConsentAction => {
  return {
    type: TOGGLE_FLASH_CARD_STATE_CONSENT,
    payload: id,
  };
};

export const toggleFlashCardState = (
  id: string,
  history: History
): ToggleFlashCardStateAction => {
  return {
    type: TOGGLE_FLASH_CARD_STATE,
    payload: { id, history },
  };
};

export const toggleFlashCardStateSuccess = (
  id: string
): ToggleFlashCardStateSuccessAction => {
  return {
    type: TOGGLE_FLASH_CARD_STATE_SUCCESS,
    payload: { id },
  };
};

export const toggleFlashCardStateError = (
  error: any
): ToggleFlashCardStateErrorAction => {
  return {
    type: TOGGLE_FLASH_CARD_STATE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Upload and Create Flash Card
export const uploadAndCreateFlashCard = (
  request: UploadAndCreateFlashCardRequest
): UploadAndCreateFlashCardAction => {
  return {
    type: UPLOAD_AND_CREATE_FLASH_CARD,
    payload: request,
  };
};

export const uploadAndCreateFlashCardSuccess = (
  response: UploadAndCreateFlashCardResponse
): UploadAndCreateFlashCardSuccessAction => {
  return {
    type: UPLOAD_AND_CREATE_FLASH_CARD_SUCCESS,
    payload: response,
  };
};

export const uploadAndCreateFlashCardError = (
  error: CreateMediaError
): UploadAndCreateFlashCardErrorAction => {
  return {
    type: UPLOAD_AND_CREATE_FLASH_CARD_ERROR,
    payload: error,
  };
};

export const uploadAndCreateFlashCardProgress = (
  progress: CreateMediaProgress
): UploadAndCreateFlashCardProgressAction => {
  return {
    type: UPLOAD_AND_CREATE_FLASH_CARD_PROGRESS,
    payload: progress,
  };
};

export const removeUploadedFlashCardImage = (
  localId: number
): RemoveUploadedFlashCardImageAction => ({
  type: REMOVE_UPLOADED_FLASH_CARD_IMAGE,
  payload: localId,
});
//#endregion
